import {
	AUTHENTICATED,
	UNAUTHENTICATED,
	AUTHENTICATION_ERROR,
	PROFILE_UPDATED,
	SAVE_BACK_LINK,
	LOGGING_OUT,
	RESET_BACK_LINK,
} from "../actions";
import decodeJwtToken from "../libs/decodeJwtToken";
import { JWTData } from "../types";
import { Location } from "history";
import { REHYDRATE } from "redux-persist";

function isTokenValid(tokenData: JWTData) {
	const now = Math.round(new Date().valueOf() / 1000);
	const exp = tokenData.exp;

	return exp > now;
}

export const initialState = {
	authenticated: false,
	token: null as string,
	refreshToken: null as string,
	userId: null as string,
	email: null as string,
	firstName: null as string,
	lastName: null as string,
	language: null as string,
	photoUrl: null as string,
	tokenRefreshed: null as number,
	refreshInterval: null as number,
	tokenExpires: null as number,
	backlink: null as Location,
	loggingOut: false,
	tokenRefreshing: null as boolean,
};

export type AuthState = typeof initialState;

function getExpirationTimestamp(timestamp: number): number {
	if (process.env.REACT_APP_AUTH_EXPIRY_TIMEOUT) {
		return new Date(Date.now() + parseInt(process.env.REACT_APP_AUTH_EXPIRY_TIMEOUT) * 1000).valueOf();
	}

	return timestamp;
}

export default function (state = initialState, action) {
	switch (action.type) {
		case AUTHENTICATED: {
			const token = action.accessToken;
			//const refreshToken = action.refreshToken;
			const decoded = decodeJwtToken(token);
			const { userId, firstName, lastName, language, photoUrl, exp } = decoded;
			const tokenExpires = getExpirationTimestamp(exp * 1000);

			const authenticated = isTokenValid(decoded);

			const tokenRefreshed = Date.now();

			return {
				...state,
				...{
					authenticated,
					//token,
					//refreshToken,
					userId,
					firstName,
					lastName,
					language,
					photoUrl,
					tokenRefreshed,
					refreshInterval: Math.floor(exp * 1000 - tokenRefreshed),
					tokenExpires,
				},
			};
		}

		case LOGGING_OUT: {
			return { ...state, ...{ loggingOut: true } };
		}

		case UNAUTHENTICATED: {
			return { ...state, ...{ authenticated: false } };
		}

		case AUTHENTICATION_ERROR: {
			return { ...state, ...{ authenticated: false } };
		}

		case "TOKEN_REFRESHED": {
			const tokenRefreshed = Date.now().valueOf();
			const tokenExpires = getExpirationTimestamp(action.tokenExpires);
			return { ...state, tokenRefreshed, tokenExpires };
		}

		case "TOKEN_REFRESHING": {
			return {
				...state, tokenRefreshing: action.refreshing
			};
		}

		case PROFILE_UPDATED: {
			if (!action.profile) {
				return state;
			}
			const { language } = action.profile;
			return { ...state, language };
		}

		case SAVE_BACK_LINK: {
			return { ...state, backlink: action.backLink };
		}

		case RESET_BACK_LINK: {
			return { ...state, backlink: null as Location };
		}

		case REHYDRATE: {
			return { ...state, ...action.payload?.auth };
		}

		default:
			return state;
	}
}
